$(document).on('click', '.saved-files-list .file-delete', function() {
    if (!confirm('Вы действительно хотите удалить этот файл?')) {
        return false;
    }
    let fileid = $(this).attr('data-file-id');
    if(fileid) {
        axios.post(`/file-upload/${fileid}/delete`)
            .then(_ => {
                $(this).parent('.item').remove();
            });
    }
});


// WEBPACK FOOTER //
// ./resources/vendor/FileUpload/js/FileUpload.js